module.exports = __webpack_public_path__ + "f1c7e06258f7f561c9532b05ecfe08ff.MP3";